import React, { useState } from 'react';
import './SubmitUpdateForm.css'; // Ensure this CSS file contains proper styles
import axiosInstance from '../axiosConfig';

const SubmitUpdateForm = ({ courseId, onClose }) => {
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [comments, setComments] = useState('');
    const [otherCategory, setOtherCategory] = useState(''); // For the "Other" input field
    const [isSubmitting, setIsSubmitting] = useState(false);

    const categories = ['Scorecard', 'Not Private Club', 'Initiation Fee', 'Annual Dues', 'Financials', 'Other'];

    const handleCategoryChange = (event) => {
        const { value, checked } = event.target;

        if (value === 'Other' && !checked) {
            setOtherCategory(''); // Clear "Other" input if unchecked
        }

        if (checked) {
            setSelectedCategories([...selectedCategories, value]);
        } else {
            setSelectedCategories(selectedCategories.filter((cat) => cat !== value));
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsSubmitting(true);

        const data = {
            club_id: courseId,     // CHANGED: Send club_id instead of course_id
            course_id: null,       // ADDED: Explicitly set course_id to null
            categories: selectedCategories.includes('Other')
                ? [...selectedCategories.filter((cat) => cat !== 'Other'), otherCategory]
                : selectedCategories,
            comment: comments,
        };

        console.log('Submitting update with data:', data); // DEBUG: Log the payload

        try {
            const response = await axiosInstance.post('/submit_update_view/', data);
            console.log('Submission successful:', response.data);
            alert('Update submitted successfully!');
            setSelectedCategories([]);
            setComments('');
            setOtherCategory('');
            onClose();
        } catch (error) {
            console.error('Error submitting update:', error.response?.data || error.message);
            alert('Failed to submit the update. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="submit-update-form overlay">
            <div className="form-container-submit-update">
                <h2>Submit Update</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-group2">
                        <label>Select Categories:</label>
                        <div className="checkbox-group">
                            {categories.map((category) => (
                                <label key={category} className="checkbox-label">
                                    <input
                                        type="checkbox"
                                        value={category}
                                        checked={selectedCategories.includes(category)}
                                        onChange={handleCategoryChange}
                                    />
                                    {category}
                                </label>
                            ))}
                        </div>
                        {selectedCategories.includes('Other') && (
                            <div className="form-group">
                                <input
                                    type="text"
                                    placeholder="Specify other category"
                                    value={otherCategory}
                                    onChange={(e) => setOtherCategory(e.target.value)}
                                    className="other-category-input"
                                />
                            </div>
                        )}
                    </div>
                    <div className="form-group">
                        <label>Comments:</label>
                        <textarea
                            placeholder="Describe the issue or update..."
                            value={comments}
                            onChange={(e) => setComments(e.target.value)}
                            className="comments-box"
                        />
                    </div>
                    <div className="form-actions">
                        <button
                            type="submit"
                            className="submit-button"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? 'Submitting...' : 'Submit'}
                        </button>
                        <button
                            type="button"
                            className="cancel-button"
                            onClick={onClose}
                            disabled={isSubmitting}
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default SubmitUpdateForm;